import { useFeedbackStore } from '@/modules/feedback/stores/feedbackStore'
import router from '@/router'
import { ERouteNames } from '@/router/ERouteNames'

interface ICalendarEventOpenSource {
  id?: number | string
  url?: string | null
  extendedProps?: {
    source?: string
  }
}

function getEntityId(event: ICalendarEventOpenSource): number | null {
  if (event.url) {
    const match = event.url.match(/\/(\d+)\/?$/) || event.url.match(/\/(\d+)\//)
    if (match) {
      const idFromUrl = Number(match[1])
      if (Number.isFinite(idFromUrl) && idFromUrl > 0) return idFromUrl
    }
  }

  const id = Number(event.id)
  return Number.isFinite(id) && id > 0 ? id : null
}

/*
 * Открывает сущность по клику на событие календаря.
 * Тип — extendedProps.source (Django _meta.object_name), id — из url или id события.
 * НС, заявка и ППУ — глобальная форма на текущей странице, аудит — карточка по роуту.
 */
export function openCalendarEvent(event: ICalendarEventOpenSource): boolean {
  const source = event.extendedProps?.source
  const entityId = getEntityId(event)
  if (!source || !entityId) return false

  const feedbackStore = useFeedbackStore()

  if (source === 'AdverseEvent') {
    feedbackStore.globalAdverseEventId = entityId
    feedbackStore.createOrUpdateAdverseEvent = true
    return true
  }

  if (source === 'Ticket') {
    feedbackStore.globalTicketId = entityId
    return true
  }

  if (source === 'Audit') {
    router.push({
      name: ERouteNames.AUDIT_DETAIL,
      params: { id: String(entityId) },
    })
    return true
  }

  if (source === 'ImprovementSuggestion' || source === 'Improvement') {
    feedbackStore.globalImprovementId = entityId
    return true
  }

  if (source === 'ResponsibilityEntry') {
    feedbackStore.globalResponsibilityEntryId = entityId
    return true
  }

  return false
}
